import { useCallback, useEffect, useState } from 'react'
import { platform } from '@/platform'
import type { SearchHitResponse } from '@/api/types'

const KEY = 'recent-patients'
const LIMIT = 8

/** Local and small on purpose: only patients opened on this device, so it is a
 *  shortcut rather than a second copy of the register. Cleared on sign-out. */
export function useRecentPatients() {
  const [recent, setRecent] = useState<SearchHitResponse[]>([])

  useEffect(() => {
    void platform.storage.get<SearchHitResponse[]>(KEY).then((stored) => setRecent(stored ?? []))
  }, [])

  const remember = useCallback(async (hit: SearchHitResponse) => {
    const stored = (await platform.storage.get<SearchHitResponse[]>(KEY)) ?? []
    const next = [hit, ...stored.filter((p) => p.id !== hit.id)].slice(0, LIMIT)
    await platform.storage.set(KEY, next)
    setRecent(next)
  }, [])

  return { recent, remember }
}
